import { render, staticRenderFns } from "./EditToolBar.vue?vue&type=template&id=60b014d0&scoped=true"
import script from "./EditToolBar.vue?vue&type=script&lang=ts"
export * from "./EditToolBar.vue?vue&type=script&lang=ts"
import style0 from "./EditToolBar.vue?vue&type=style&index=0&id=60b014d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b014d0",
  null
  
)

export default component.exports